import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import 'rxjs/add/operator/map';
import { config } from "../../config";

@Injectable()
export class NotificationService {

    constructor(private httpClient: HttpClient) { }
    baseUrl: string = config.apiUrl;
    getHeaders(): HttpHeaders {
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return headers;
    }
    sendNotificationMessageForAndroid(message: any): Observable<any> {
        const pushNotificationUrlForAndroid = this.baseUrl + 'Notification/sendPushNotificationForAndroid'
        return this.httpClient.post(pushNotificationUrlForAndroid, message, { headers: this.getHeaders() }).map((response) => {
            return response;
        })
    }
    sendNotificationMessageForApple(message: any): Observable<any> {
        const pushNotificationUrlForApple = this.baseUrl + 'Notification/sendPushNotificationForApple'
        return this.httpClient.post(pushNotificationUrlForApple, message, { headers: this.getHeaders() }).map((response) => {
            return response;
        })
    }
    addNotificationHistory(notificationHistoryDTO: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'Notification/addNotificationHistory', notificationHistoryDTO, { headers: this.getHeaders() })
            .map((response) => {
                return response;
            });
    }
    getNotificationHistoryByProductId(productId: number): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'Notification/getNotificationHistoryByProductId/' + productId, { headers: this.getHeaders() })
            .map((response) => {
                return response;
            })
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/NotificationService.ts